import configment from '@adc/configment'
import logger from '@adc/logger'
// @ts-ignore no types
import { get, pick } from 'lodash'
// @ts-ignore no types
import newAnalytics from '@adc/analytics'

// TODO: this file really needs to be cleaned up (remove old stuff) and changed to typescript

const SHOULD_FIRE_PAGE_GA_TRACKING = false
const CHANNEL = 'resi-fe-pdp'
export const BID_DEPOSIT_EVENT_NAME = 'bid_deposit'
const REO_PDP_PAGE_NAME = 'pdp|reo'
// const CONTRACT_PAGE_NAME = 'contract'
const analytics = {}
let everyCall = {}

const commonTrackingValues = () => {
  return {
    ...pick(everyCall, ['morpheusListingId', 'morpheusPropertyId']),
  }
}

const ACTION_VALUES = {
  /**
   * Login/Signup
   */
  LOGIN: 'login',
  SIGNUP: 'signup',

  /**
   * Options Ribbon
   */
  PRINT: 'print',
  DIRECTIONS: 'directions',

  /**
   * PropertyGallery component
   */
  IMAGES_VIEW: 'photos',
  MAP_VIEW: 'map',
  STREET_VIEW: 'street',

  /**
   * Contacting an agent
   */
  CONTACT_AGENT: 'contact_agent|listingagent',
  OPEN_HOUSE: 'contact_agent|openhouse',

  /**
   * Chat
   */
  CHAT: 'chat',

  /**
   * Saved assets
   */
  SAVED_ASSET: 'savedasset',
  VIEW_SAVED_ASSETS: 'viewallsaved',

  /**
   * Contracting
   */
  CONTRACTING_FORM_SUBMIT: 'contracting-form-submit',
  CONTRACTING_SUBMIT_SUCCESS: 'success',
  CONTRACTING_SUBMIT_FAILURE: 'fail',

  /**
   * Purchase Profiles
   */
  PURCHASE_PROFILES_SELECT_PROFILE:
    'contracting-purchase-profiles-select-profile',
  PURCHASE_PROFILES_UPDATE_PROFILE:
    'contracting-purchase-profiles-update-profile',
  PURCHASE_PROFILES_CREATE_PROFILE:
    'contracting-purchase-profiles-save-new-profile',

  /**
   * Other
   */
  EVENT_DETAILS: 'event.details',
  REGISTRATION_START: 'registration|start',
  PROPERTY_WATCH: 'propertywatchsubmitted',
  SEARCH_AGAIN: 'search_again',

  /**
   * TPS
   */
  TERMS_LIGHTBOX: 'whataretheseterms',
  FORECLOSURE_FAQ: 'foreclosurefaq',
  PROPERTY_APPRAISER: 'contacts.appraiser',
  CLERK_COURT: 'contacts.clerkofcourt',
  CUST_SERVICE: 'contacts.CS',
  BORROWERS: 'contacts.Borrowers',
  VENUE: 'event.location',
  BID_COUNTY: 'bidatcountysite',
  BID_COUNTY_CONTINUE: 'countysitecontinue',
  BID_COUNTY_CHECKBOX: 'countysitecheck',
  WHAT_TO_BRING: 'whattobring',
  VIEW_ALL_DOCS: 'viewalldocs',
  EMAIL: 'email',
  BID_NOW_BUTTON: 'bidnow',
  BID_PLACED: 'bidplaced',
  MAX_BID_INFO_TOOLTIP: 'maxbidinfotooltip',
  EST_VALUE_RANGE_INFO_TOOLTIP: 'estvaluerangeinfotooltip',
  CLOSE_CONFIRM_LB: 'bidcloseconfirmlightbox',
  CONFIRM_LB: 'bidconfirmlightbox',
  SHOW_BID_HISTORY: 'bidhistory',
  REGISTRATION_CLOSED: 'tpsregistrationclosed',
  REGISTRATION_COMPLETED: 'tpsregistrationcompleted',
  REG_CHAT: 'tpsregistrationchat',
  REG_SOURCE: 'tpsregistration',
  PARTICIPATION_TERMS: 'tpsregistrationparticipationterms',
  PDP_SOURCE: 'pdp|trustee',

  /**
   * Make Your Offer
   */
  MAKE_YOUR_OFFER: 'make-your-offer-pdp',

  /**
   * Similar Properties
   */
  SIMILAR_PROPERTY_CLICK: 'similar-properties-click',

  /**
   * First Look Modal
   */
  FIRST_LOOK_MODAL_BACK: 'first-look-modal-back',
  FIRST_LOOK_MODAL_DONE: 'first-look-modal-done',
}

const FIRST_LOOK_MODAL = {
  START: 'first-look-modal-start',
  ACKNOWLEDGEMENTS: 'first-look-modal-step-2',
  COMPLETE: 'first-look-modal-complete',
}

const { track, eventNames, standardTracking } = newAnalytics

/**
 * Initializes our analytics library and tracks the initial page load.
 *
 * @param {Property}
 * @param {Object}
 * @param {Object}
 * @param {Object}
 */
function initialize(propertyContext, user = {}, featureFlags = {}) {
  const googleAnalyticsPath = window.location.pathname

  // Setting inital GTM Values
  const dataObject = {
    auctionId: propertyContext['auction.id'],
    statusLabel: propertyContext.statusLabel,
    estCreditBid: propertyContext.estCreditBid || '',
    reserve: propertyContext.reserve,
    propertyType: propertyContext['property.type'],
    venueId: propertyContext.venueId,
    equityNumber: propertyContext['property.equityNumber'],
    ...propertyContext.listing,
    ...(featureFlags['fe.resi.ab.testing.onboarding_drawer'] &&
      featureFlags['fe.resi.ab.testing.onboarding_drawer']?.test),
    ...(featureFlags['fe.resi.ab.testing.signup-propositions'] &&
      featureFlags['fe.resi.ab.testing.signup-propositions']?.test),
    ...(featureFlags['fe.resi.ab.testing.pdp.save.icon'] &&
      featureFlags['fe.resi.ab.testing.pdp.save.icon']?.test),
    ...(featureFlags['fe.resi.ab.testing.onboarding_drawer_content'] &&
      featureFlags['fe.resi.ab.testing.onboarding_drawer_content']?.test),
    ...(featureFlags['fe.resi.enabled-photo-enhancement'] &&
      featureFlags['fe.resi.enabled-photo-enhancement']?.test),
    ...(featureFlags['fe.resi.ab.testing.signup.thank-you-page'] &&
      featureFlags['fe.resi.ab.testing.signup.thank-you-page']?.test),
    ...(featureFlags?.['fe.resi.ab.testing.onboarding-drawer-delay'] || {}),
  }
  if (user) {
    newAnalytics.trackDataLayerLoaded(user, dataObject)
  }

  newAnalytics
    .init(configment.get())
    .then(() => {
      everyCall = {
        channel: CHANNEL,
        ...propertyContext,
        ...pick(dataObject, [
          'productType',
          'morpheusListingId',
          'morpheusPropertyId',
        ]),
      }

      newAnalytics.firePageTrackingWithContext(
        googleAnalyticsPath,
        SHOULD_FIRE_PAGE_GA_TRACKING
      )
    })
    .catch(logger.err)
}

analytics.track = ({ eventName = '', additionalFields = {} }) => {
  track(eventName, {
    ...additionalFields,
  })
}

analytics.bidDeposit = {
  track: ({ eventName = '', additionalFields = {} }) => {
    track(eventName, {
      type: BID_DEPOSIT_EVENT_NAME,
      event_category: BID_DEPOSIT_EVENT_NAME,
      ...additionalFields,
    })
  },
}

/**
 * Popup
 */
analytics.popup = (tooltipName, additionalFields = {}) => {
  track(newAnalytics.eventNames.hoverEvent, {
    tooltipName,
    ...additionalFields,
  })
}

/**
 * Documents
 */
analytics.documents = doc => {
  // Google Tag Manager dataLayer
  doc &&
    track(newAnalytics.eventNames.download, {
      downloadText: doc.label,
      ...commonTrackingValues(),
    })
}

analytics.compInteraction = compAddress => {
  compAddress &&
    track(newAnalytics.eventNames.localCompsMapClick, {
      compAddress,
    })
}

/**
 * Property
 */
analytics.property = {
  save: (listing = {}) => {
    newAnalytics.trackPropertySave(listing, 'save')
  },
  saveSimilarProperty: (listing = {}, save = true) => {
    track(newAnalytics.eventNames.similarPropertySave, {
      status: 'success',
      action: save ? 'save' : 'remove',
      ...newAnalytics.standardTracking.listing(listing),
    })
  },
  trackSimilarPropertyClick: (listing, additionalPropertyData = {}) => {
    track(newAnalytics.eventNames.similarPropertiesClick, {
      ...additionalPropertyData,
      ...newAnalytics.standardTracking.listing(listing),
    })
  },
  removeSaved: (listing, additionalPropertyData) => {
    newAnalytics.trackPropertySave(listing, 'remove', additionalPropertyData)
  },
}

analytics.bidBanner = {
  // For easier reporting, bidStatus is consistently updated, even when the user is logged out.
  unauthenticatedStatusChange: () => {
    track(newAnalytics.eventNames.bidStatusChange, {
      bidStatus: 'unauthenticated',
    })
  },
  bidStatusChange: bidStatus => {
    track(newAnalytics.eventNames.bidStatusChange, {
      bidStatus,
    })
  },
  confirmBid: {
    success: () => {
      track(newAnalytics.eventNames.confirmBid, {
        confirmationStatus: 'success',
        ...commonTrackingValues(),
      })
    },
    fail: () => {
      track(newAnalytics.eventNames.confirmBid, {
        confirmationStatus: 'fail',
        ...commonTrackingValues(),
      })
    },
  },
  confirmProxyBid: {
    success: () => {
      track(newAnalytics.eventNames.confirmProxyBid, {
        confirmationStatus: 'success',
        ...commonTrackingValues(),
      })
    },
    fail: () => {
      track(newAnalytics.eventNames.confirmProxyBid, {
        confirmationStatus: 'fail',
        ...commonTrackingValues(),
      })
    },
  },
}

analytics.purchaseTitleReport = () => {
  track(newAnalytics.eventNames.purchaseTitleReport, {
    ...commonTrackingValues(),
  })
}

/**
 * TPS trackings
 *
 * NOTE: Was this copied over from tps-pdp and never changed? So that we have multple differnt ways to track the same
 * property data between product type variants? Man this is poop. Needs some rework here.
 */
analytics.trackPDP = ({ featureFlags, listing, user = {} }) => {
  const googleAnalyticsPath = window.location.pathname

  // Setting initial GTM Values
  user &&
    newAnalytics.trackDataLayerLoaded(user, {
      auctionId: get(listing, 'event.event_id', ''),
      statusLabel: get(listing, 'listing_status_label', ''),
      estCreditBid: get(listing, 'reserve_price', ''),
      propertyType: get(
        listing,
        'primary_property.summary.structure_type_code'
      ),
      equityNumber: get(listing, 'potential_return_score', 0),
      venueId: get(listing, 'venue.venue_id', ''),
      ...newAnalytics.standardTracking.listing(listing),
      ...(featureFlags['fe.resi.ab.testing.onboarding_drawer'] &&
        featureFlags['fe.resi.ab.testing.onboarding_drawer']?.test),
      ...(featureFlags['fe.resi.ab.testing.signup-propositions'] &&
        featureFlags['fe.resi.ab.testing.signup-propositions']?.test),
      ...(featureFlags['fe.resi.ab.testing.pdp.save.icon'] &&
        featureFlags['fe.resi.ab.testing.pdp.save.icon']?.test),
      ...(featureFlags['fe.resi.ab.testing.onboarding_drawer_content'] &&
        featureFlags['fe.resi.ab.testing.onboarding_drawer_content']?.test),
      ...(featureFlags['fe.resi.enabled-photo-enhancement'] &&
        featureFlags['fe.resi.enabled-photo-enhancement']?.test),
      ...(featureFlags['fe.resi.ab.testing.signup.thank-you-page'] &&
        featureFlags['fe.resi.ab.testing.signup.thank-you-page']?.test),
      ...(featureFlags?.['fe.resi.ab.testing.onboarding-drawer-delay'] || {}),
    })

  newAnalytics
    .init(configment.get())
    .then(() => {
      const summary = get(listing, 'primary_property.summary', {})
      const address = summary.address || {}

      everyCall = {
        channel: CHANNEL,
        'property.type': get(
          listing,
          'primary_property.summary.structure_type_code',
          ''
        ),
        'property.city': get(address, 'municipality', ''),
        'property.county': get(address, 'country_secondary_subdivision', ''),
        'property.state': get(address, 'country_primary_subdivision', ''),
        'property.address': get(summary, 'formatted_address', ''),
        'property.occupancyStatus': get(
          listing,
          'listing_configuration.occupancy_status',
          ''
        ),
        lob: get(listing, 'listing_configuration?.product_type', ''),
        startingBid: get(listing, 'auction.starting_bid', 0),
        'event.id': get(listing, 'event.event_code', ''),
        'auction.id': get(listing, 'event.event_id,', '0'),
        'venue.id': get(listing, 'venue.venue_id', ''),
        'venue.type': get(listing, 'venue.venue_type', ''),
        'asset.type': get(listing, 'listing_configuration?.asset_type', ''),
        'auction.date': get(listing, 'auction.auction_date', ''),
        status: get(listing, 'listing_status_label', '').replace(/ /g, ''),
        ...newAnalytics.standardTracking.listing(listing),
      }

      newAnalytics.firePageTrackingWithContext(
        googleAnalyticsPath,
        SHOULD_FIRE_PAGE_GA_TRACKING
      )
    })
    .catch(logger.err)
}

analytics.trackPrint = data =>
  track(
    newAnalytics.eventNames.print,
    newAnalytics.standardTracking.listing(data)
  )

analytics.trackMakeYourOfferClick = () =>
  track(newAnalytics.eventNames.makeYourOfferPDP)
/**
 * First Look Modal
 */
analytics.firstLookModal = {
  start: () => {
    track(newAnalytics.eventNames.firstLookModal.start)
  },
  acknowledgements: buyerCertificationType => {
    track(newAnalytics.eventNames.firstLookModal.step2, {
      buyerCertificationType,
    })
  },
  back: buyerCertificationType => {
    track(newAnalytics.eventNames.firstLookModal.back, {
      buyerCertificationType,
    })
  },
  done: buyerCertificationType => {
    track(newAnalytics.eventNames.firstLookModal.done, {
      buyerCertificationType,
    })
  },
  complete: buyerCertificationType => {
    track(newAnalytics.eventNames.firstLookModal.complete, {
      buyerCertificationType,
    })
  },
}

analytics.matchBidding = {
  matchWinningBidButtonClick: status =>
    track(newAnalytics.eventNames.matchWinningBidButtonClick, {
      status,
      ...commonTrackingValues(),
    }),
  matchWinningBidConfirmationClick: status =>
    track(newAnalytics.eventNames.matchWinningBidConfirmationClick, {
      status,
      ...commonTrackingValues(),
    }),
}

analytics.remoteBidding = {
  qualifyRemoteBidButtonClick: isUserLoggedIn =>
    track(newAnalytics.eventNames.qualifyRemoteBidButton, {
      ...commonTrackingValues(),
      userLoggedIn: isUserLoggedIn,
    }),
  joinTheAuctionRemoteBidButtonClick: isUserLoggedIn =>
    track('pdp-join-auction-now-click', {
      ...commonTrackingValues(),
    }),
}

analytics.privateSeller = {
  makeAnOfferBidBoxButtonClick: () =>
    track('make-an-offer-bid-box', {
      ...commonTrackingValues(),
    }),
  makeAnOfferStickyHeaderButtonClick: () =>
    track('make-an-offer-sticky-header', {
      ...commonTrackingValues(),
    }),
  buyNowTabClick: () =>
    track('pdp-buy-now-tab', {
      ...commonTrackingValues(),
    }),
  makeAnOffer: ({ intent, status, listing }) =>
    analytics.track({
      eventName:
        intent === 'submit' ? 'make-an-offer-submit' : 'make-an-offer-update',
      additionalFields: {
        ...standardTracking.listing(listing),
        status,
      },
    }),
}

analytics.initialize = initialize

export default analytics
export {
  ACTION_VALUES,
  REO_PDP_PAGE_NAME,
  FIRST_LOOK_MODAL,
  eventNames,
  standardTracking,
}
